import React from 'react'
import { useParams } from 'react-router'
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import useAPI from 'src/hooks/useAPI'
import useValid from 'src/hooks/useValid'
import {
  CertInput,
  CertInputContainer,
  CertSubmitBtn,
  PhoneVerificationWrap,
  ReCertBtn,
  Telecoms,
  TelInput,
  TelPhoneNumWrap,
  TelSelectorWrap,
} from 'src/styles/views/join/PhoneVerification'
import Timer from 'src/components/common/Timer'
import { PramsKeys } from 'src/types/type'
import { useTelList } from 'src/hooks/useTelList'
import Loading from '../common/Loading'
import {
  CertNumState,
  MvnoCheckValue,
  RecoilStateList,
  TelTypeState,
  uiData,
} from 'src/recoil/ui'
import { useCheckTelecomIsBlock } from 'src/hooks/useCheckTelecomIsBlock'
import { getTermsAgree } from 'src/service/join'
import { useAutoInputGuard } from "src/hooks/useAutoInputGuard";

const PhoneVerification = (props: any): JSX.Element => {
  const { onMoveToElement, RefInput, submit } = props
  const { pcode } = useParams<PramsKeys>()
  const telList = useTelList()
  const handleValid = useValid()
  const CertApi = useAPI('SENDCAPTCHAEXPRESS')
  const JoinApi = useAPI('SENDOTPVERFY')

  useCheckTelecomIsBlock()

  const { TelType, PhoneNum, CertNum, CertCheck, termsAgree, TransId, UserType, Timeout } =
    useRecoilValue(RecoilStateList)
  const mvnoCheckValue = useRecoilValue(MvnoCheckValue)
  const setTelType = useSetRecoilState(TelTypeState)
  const ResetCertNum = useResetRecoilState(CertNumState)
  const {
    layoutsConfirm: { submitBtn },
    layoutsInsert: {
      certs: { backgroundColor: certsBgColor, borderColor: certsBorderColor },
      agency: { actColor: telecomBackground },
    },
  } = useRecoilValue(uiData)

  const { mutateAsync: getSendOtp, isLoading: certLoading } = CertApi.useSetMutation({
    TeleType: TelType.toString(),
    PNumber: PhoneNum,
    AuthType: 'Add',
    Pcode: pcode,
    CALLTYPE: UserType,
  })
  const { mutateAsync: JoinRequest, isLoading: joinLoading } = JoinApi.useSetMutation({
    TeleType: TelType.toString(),
    PNumber: PhoneNum,
    Pcode: pcode,
    TransactionID: TransId,
    CryptoNumber: CertNum,
    AuthType: 'Add',
    TermsAgree: getTermsAgree(termsAgree, TelType, mvnoCheckValue),
    CALLTYPE: UserType,
  })
  const handleJoinOnKeyUp = useAutoInputGuard(() => submit.join(JoinRequest))

  const requestCert = () => {
    submit.validationCert(getSendOtp)
    ResetCertNum()
    setTimeout(() => {
      document.getElementById('certInput')?.focus()
    }, 1000)
  }

  const CertOnKeyUpFunc = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') requestCert()
  }
  const TelecomSelector = async (option: number) => {
    setTelType(option)

    onMoveToElement()
  }
  return (
    <PhoneVerificationWrap backgroundColor={certsBgColor} borderColor={certsBorderColor}>
      <Loading active={certLoading || joinLoading} />
      <TelSelectorWrap>
        {telList?.map((element) => (
          <Telecoms
            key={element.idx}
            className={element.text}
            bgActive={TelType === element.idx}
            oneTelStyle={telList?.length === 1}
            actColor={telecomBackground}
            disabled={CertCheck}
            onClick={() => TelecomSelector(element.idx)}
          />
        ))}
      </TelSelectorWrap>
      <TelPhoneNumWrap>
        <TelInput
          className="ipt_phonenumber"
          borderColor={telecomBackground}
          backgroundColor={!CertCheck ? '#fff' : '#ccc'}
          type="tel"
          ref={RefInput}
          placeholder="휴대폰번호를 입력하세요."
          maxLength={11}
          value={PhoneNum}
          onChange={handleValid.phoneNumValid}
          onKeyUp={CertOnKeyUpFunc}
          disabled={CertCheck}
          onClick={onMoveToElement}
        />
        {!CertCheck ? (
          <CertSubmitBtn
            className="btn_send_sms"
            {...submitBtn}
            backgroundColor={submitBtn.backgroundColor}
            onClick={requestCert}
          >
            인증번호 발송
          </CertSubmitBtn>
        ) : (
          <section>
            <CertInputContainer>
              <CertInput
                id={'certInput'}
                className="ipt_smscode"
                type="tel"
                inputMode="numeric"
                autoComplete={'one-time-code'}
                placeholder="인증번호 입력"
                maxLength={4}
                value={CertNum}
                onChange={handleValid.certNumValid}
                onKeyUp={handleJoinOnKeyUp}
              />
              <Timer time={Timeout} />
            </CertInputContainer>
            <ReCertBtn onClick={requestCert}>재전송</ReCertBtn>
          </section>
        )}
      </TelPhoneNumWrap>
    </PhoneVerificationWrap>
  )
}

export default PhoneVerification
